import { FC } from "react";
import {
  Box,
  createStyles,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { formatCurrencyAmount, formatDate, formatNumber } from "lib/format";
import { SaleHistory as SaleHistoryType } from "services/listings/types";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    historyItem: {
      fontSize: "1rem",
    },
    link: {
      color: theme.custom.palette.blue.main,
      "&:hover": {
        color: theme.custom.palette.blue.main,
      },
    },
  }),
);

const historyKindToDisplay = {
  auction: "Auction",
  direct_listing: "Listing",
  secondary_listing: "Listing",
  instant_offer: "Standing Order",
};

const formatMultiple = (multiple?: number) =>
  multiple ? `(${formatNumber(multiple)}x)` : "";

export interface SaleHistoryProps {
  saleHistory: SaleHistoryType[];
}

const SaleHistory: FC<SaleHistoryProps> = ({ saleHistory }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" data-testid="sale-history">
      <Typography variant="h6">Sale History</Typography>
      {saleHistory.map(sale => {
        const listingId = ["direct_listing", "secondary_listing"].includes(
          sale.kind,
        )
          ? ` #${sale.id}`
          : "";
        const content = `${formatDate(sale.date)} ${formatCurrencyAmount(
          sale.currency,
          sale.amount,
          2,
        )} ${formatMultiple(sale.multiple)} - ${
          historyKindToDisplay[sale.kind]
        }${listingId}`;
        if (sale.url) {
          return (
            <Link
              key={content}
              className={`${classes.historyItem} ${classes.link}`}
              href={sale.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content}
            </Link>
          );
        }
        return (
          <Typography key={content} className={classes.historyItem}>
            {content}
          </Typography>
        );
      })}
    </Box>
  );
};

export default SaleHistory;
